import { render } from "./VersionChecker.vue?vue&type=template&id=61feab70"
import script from "./VersionChecker.vue?vue&type=script&lang=js"
export * from "./VersionChecker.vue?vue&type=script&lang=js"

import "./VersionChecker.vue?vue&type=style&index=0&id=61feab70&lang=scss"

import exportComponent from "/home/forge/deployments/control-center.conneqt.io/new/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__